// Preact
// eslint-disable-next-line no-unused-vars
import { Fragment, h } from 'preact';
import { useContext } from 'preact/hooks';
import { SearchContext } from '../contexts/Search';

/**
 *
 * @returns
 */
const Overlay = () => {
	const { state } = useContext( SearchContext );
	const { loading, loadMore } = state;

	return (
		<div
			className="faceted-search__overlay py-4"
			style={loading && !loadMore && 'visibility: visible; opacity: 1;'}>
		</div>
	);
};

export default Overlay;
